/* eslint-disable react-hooks/exhaustive-deps */

import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { IQuestion } from "@/types/types";
import type { InpectionPhase } from "../../inspection.d";
import { useQuery } from "@tanstack/react-query";
import { usePhase } from "@/store/usePhase";
import { getAnswers, getAnswersByPhases } from "@/lib/services/answers";
import { useParams } from "react-router-dom";
import { useEffect, useMemo } from "react";
import QuestionCard from "./QuestionCard";

const InspectionViewMobile = ({
  questions,
  phases,
}: {
  questions: IQuestion[];
  phases: InpectionPhase[];
}) => {
  const { inspectionId } = useParams() as { inspectionId: string };
  const translate = useTranslate();

  const { setCompleted } = usePhase();
  const currentPhase = usePhase((store) => store.currentPhase!);
  const phaseLabel = usePhase((store) => store.phaseLabel!);

  const queryKey = useMemo(() => `answers-${currentPhase}`, [currentPhase]);

  const { data: currentData } = useQuery({
    queryKey: [queryKey, { inspectionId, currentPhase }],
    queryFn: () =>
      getAnswers({
        inspectionId: Number(inspectionId),
        phaseId: currentPhase,
      }),
    placeholderData: [],
  });

  const { data: restOfAnswers } = useQuery({
    queryKey: ["not_current_phases", { inspectionId, currentPhase }],
    queryFn: () =>
      getAnswersByPhases({
        inspectionId: Number(inspectionId),
        phasesId: phases
          .filter((phase) => phase.phaseId !== currentPhase)
          .map((phase) => phase.phaseId),
      }),

    placeholderData: {},
  });

  useEffect(() => {
    if (currentPhase && inspectionId && currentData) {
      setCompleted(currentData.length);
    }
  }, [currentData, currentPhase]);

  return (
    <div className="">
      <div className="p-4">
        <h3 className="text-ib-main font-ib-bold text-ib-gray-darksest">
          {translate("actionToDo")}
        </h3>
      </div>
      <div className="grid grid-cols-1 divide-y divide-ib-gray-light-1">
        {questions.map((question, index) => {
          let answer;

          if (restOfAnswers?.phases && restOfAnswers.phases[currentPhase]) {
            answer = restOfAnswers.phases[currentPhase]?.find(
              (answer: any) => answer.questionId === question.questionId,
            );
          } else {
            answer = currentData?.find(
              (answer: any) => answer.questionId === question.questionId,
            );
          }

          return (
            <QuestionCard
              key={`mobile-question-${question.questionId}`}
              question={question}
              answer={answer}
              index={index + 1}
              restOfAnswers={restOfAnswers?.phases || {}}
              phaseDate={{
                phaseLabel,
                currentPhase,
                phases,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
export default InspectionViewMobile;
